import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {

  @Input() rate?: any;
  @Input() numberOfReviews?: any;
  
  currentRate:number = 0.00;
  currentNumberOfReviews:number = 0;

  constructor() { }

  ngOnInit(): void {
    this.currentRate = this.rate ?? 0.00;
    this.currentNumberOfReviews = this.numberOfReviews ?? 0;
  }

}
